export default "__VITE_ASSET__CmsW00IB__"